import React, { Suspense, lazy } from 'react';
import { Route, Redirect, Switch, withRouter, Link } from 'react-router-dom';
import clsx from 'clsx';
import { Box, makeStyles, useTheme } from '@material-ui/core';
import AppBar from '../../Components/Header/newIndex';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import Slide from '@material-ui/core/Slide';

import Home from '../Homepage';
import Notification from '../Notification/index';
import SideNavigation from '../../Components/SideNavigation/sideNavigation';
import SendMail from '../Mail/index';
import Sms from '../Sms';
import Event from '../Event/index';
// import TimeTable from '../TimeTable/index';

import ETL from '../ETL/index';
import Logo from '../../Assets/ken42-logo.jpg';

import ETLHome from '../ETL/Pages/home';
import ETLFileUpload from '../ETL/Pages/fileUpload';
// import { useTranslation } from 'react-i18next';
import routes from '../../Utils/routes.json';
import Department from '../../Components/setup/masters/departments';
import Bankaccount from '../../Components/setup/masters/bank-accounts/bank-accounts';
import Employee from '../../Components/setup/masters/employees/employees';
import Designation from '../../Components/setup/masters/designation/designation';
import Payslip from '../../Components/setup/masters/payslip/payslip';
import Shift from '../../Components/setup/masters/shift/shift';
import WorkingDays from '../../Components/setup/masters/working-hours/working-hours';
import LeavePolicy from '../../Components/setup/masters/leaves/leaves';
import Holiday from '../../Components/setup/masters/myHolidays/myHolidays';
import Mypayslip from '../../Components/MyPayslip';
import Investment from '../../Components/MyInvestment';
import { getDashboardCardArray } from '../../Utils/dashboardCards';
import { useTranslation } from 'react-i18next';
import AssignRoles from '../ManageRoles/AssignRoles/index';
import CurrentProgrammes from '../AcademicsPlanner/CurrentProgrammes/';
import ProgramDetails from '../AcademicsPlanner/ProgramDetails';
import FacultyDetails from '../AcademicsPlanner/AddProgram/FacultyDetails';
import FacultyManagement from '../AcademicsPlanner/FacultyManagement/';
import ContractManagement from '../AcademicsPlanner/ContractManagement';
import SubjectDocuments from '../AcademicsPlanner/SubjectDocuments';
import TimeTables from '../AcademicsPlanner/TimeTable';
import TimeTable from '../AcademicsPlanner/TimeTable/TimeTable';
import AddProgram from '../AcademicsPlanner/AddProgram/';
import AddActivity from '../AcademicsPlanner/AddActivity/';

import StudentStatus from '../AdminPortal/Exam/StudentStatus';
import Exam from '../AdminPortal/Exam/index';
import QuestionPaper from '../AdminPortal/Exam/QuestionPaper';
import ChatSection from '../AdminPortal/Exam/QuestionPaper/ChatSection';
import SeatingPlan from '../AdminPortal/Exam/SeatingPlan/SeatingPlan';
import SeatingPlanArrangement from '../AdminPortal/Exam/SeatingPlan/SeatingPlanArrangement';
import Invigilation from '../AdminPortal/Exam/Invigilation/Invigilation';
import InvigilationAssign from '../AdminPortal/Exam/Invigilation/InvigilationAssign';
import InvigilationNotification from '../AdminPortal/Exam/Invigilation/InvigilationNotification';
import Evaluation from '../AdminPortal/Exam/Evaluation/Evaluation';
import Grading from '../AdminPortal/Exam/Invigilation/Grading/Grading';
import GradingDetails from '../AdminPortal/Exam/Invigilation/Grading/GradingDetails';
import GradingSetting from '../AdminPortal/Exam/Invigilation/Grading/GradingSetting';
import ViewQuestionPaper from '../AdminPortal/Exam/QuestionPaper/ViewQuestionPaper';
import FullCalendar from '../AcademicsPlanner/FullCalendar/FullCalendar';
import StudentEnrollment from '../Enrollment/StudentEnrollment/index';
import FacultyEnrollment from '../Enrollment/FacultyEnrollment/index';
import RevaluationRetest from '../AdminPortal/Exam/Revaluation Retest';

import '../../style/index.css';
import SessionScheduler from '../AcademicsPlanner/FullCalendar/SessionScheduler';
import SessionPlanner from '../AcademicsPlanner/SessionPlanner/index';
import TimeTableNew from '../AcademicsPlanner/TimeTableNew/TimeTableNew';
import KenLoader from '../../Components/KenLoader';
import { AppContextProvider, useAppContext } from '../../Utils/context';
import { useSnackbar } from 'notistack';

import AcademicCalendar from '../AcademicsPlanner/AcademicCalendar/';

const drawerWidth = 260;

const TTMaster = lazy(() => import('../TimeTable'));

function Index(props) {
  const { history } = props;
  const theme = useTheme();
  const { t } = useTranslation();

  const [openDrawer, setOpenDrawer] = React.useState(false);

  const useStyles = makeStyles((theme) => ({
    mainContainer: {
      display: 'flex',
      background: theme.palette.KenColors.background,
      // padding: 32,
      minHeight: `calc(100vh - 64px)`,
      marginTop: 64,
      overflow: 'hidden',
    },
    containerWrap: {
      width: openDrawer ? `calc(100% - 260px)` : `calc(100% - 64px)`,
      padding: '0 32px',
      marginBottom: '50px',
    },
    appBar: {
      [theme.breakpoints.up('smUp')]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        zIndex: 1000,
      },
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerOpen: {
      width: drawerWidth,
      overflow: 'hidden',
      overflowY: 'scroll',
      // background: theme.palette.KenColors.primary,
      backgroundColor: theme.palette.KenColors.kenLogoColor,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        opacity: '0.2',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#C4C4C4',
        borderRadius: '30px',
        opacity: '0.1',
        outline: `1px solid transparent`,
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: `#02195E`,
      },
    },
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      // background: theme.palette.KenColors.primary,
      backgroundColor: theme.palette.KenColors.kenLogoColor,
      overflowX: 'hidden',
      overflowY: 'hidden',

      width: theme.spacing(7) + 1,
      [theme.breakpoints.up('sm')]: {
        width: 65,
      },
      [theme.breakpoints.down('xs')]: {
        width: 65,
      },
    },
    toolbar: theme.mixins.toolbar,
  }));
  const classes = useStyles();
  const handleClick = () => {
    history.push('/dashboard');
  };
  console.log('drawerWidth', openDrawer);
  const { isLoading = false } = useAppContext();

  return (
    <>
      <Box className={classes.mainContainer}>
        {isLoading && <KenLoader />}
        <div className="side-nav-scroll">
          <Drawer
            className={clsx(classes.drawer, {
              [classes.drawerOpen]: openDrawer,
              [classes.drawerClose]: !openDrawer,
            })}
            classes={{
              paper: clsx({
                [classes.drawerOpen]: openDrawer,
                [classes.drawerClose]: !openDrawer,
              }),
            }}
            variant="permanent"
            open
          >
            <SideNavigation
              openDrawer={openDrawer}
              setOpenDrawer={setOpenDrawer}
            />
          </Drawer>
        </div>

        <div className={classes.containerWrap}>
          <AppBar
            logo={Logo}
            title="Admin Portal"
            handleClick={handleClick}
            history={history}
            // titleStyle={clsx({
            //   [classes.labelOpen]: openDrawer,
            //   [classes.labelClose]: !openDrawer,
            // })}
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
            cards={getDashboardCardArray(t)}
          />

          <Box className={classes.container}>
            <Suspense fallback={<div>Loading...</div>}>
              <Switch>
                <Route exact path={`${routes.main}`}>
                  <Redirect to={`${routes.currentProgrammes}`} />
                </Route>
                <Route exact path={`${routes.main}/home`}>
                  <Home />
                </Route>
                {/* academics-planner */}
                <Route exact path={routes.currentProgrammes}>
                  <CurrentProgrammes />
                </Route>
                <Route exact path={routes.currentProgramDetails}>
                  <ProgramDetails />
                </Route>
                <Route exact path={routes.facultyDetails}>
                  <FacultyDetails />
                </Route>
                <Route exact path={routes.addProgram}>
                  <AddProgram />
                </Route>

                <Route exact path={routes.addActivity}>
                  <AddActivity />
                </Route>
                <Route exact path={routes.sessionSchedulerOld}>
                  <TimeTables />
                </Route>
                <Route exact path={routes.fullCalendar}>
                  <FullCalendar />
                </Route>
                <Route exact path={routes.sessionScheduler}>
                  <SessionScheduler />
                </Route>
                <Route exact path={routes.sessionPlanner}>
                  <SessionPlanner />
                </Route>
                <Route exact path={routes.facultySection}>
                  <FacultyManagement />
                </Route>
                {/* Enrollment */}
                <Route exact path={routes.enrollStudent}>
                  <StudentEnrollment />
                </Route>
                <Route exact path={routes.enrollFaculty}>
                  <FacultyEnrollment />
                </Route>
                {/* admin-management */}
                {/* <Route exact path={routes.adminManagement}>
                  <Redirect to={routes.exam} />
                </Route> */}
                <Route exact path={routes.exam}>
                  <Exam />
                </Route>
                <Route exact path={routes.studentStatus}>
                  <StudentStatus />
                </Route>
                <Route exact path={routes.seatingPlan}>
                  <SeatingPlan />
                </Route>
                <Route exact path={routes.invigilationProctoring}>
                  <Invigilation />
                </Route>
                <Route exact path={routes.evaluation}>
                  <Evaluation />
                </Route>
                <Route exact path={routes.grading}>
                  <Grading />
                </Route>
                <Route exact path={routes.gradingDetails}>
                  <GradingDetails />
                </Route>
                <Route exact path={routes.invigilationProctoringNotification}>
                  <InvigilationNotification />
                </Route>
                <Route exact path={routes.invigilationProctoringAssign}>
                  <InvigilationAssign />
                </Route>
                <Route exact path={routes.seatingPlanArrangement}>
                  <SeatingPlanArrangement />
                </Route>
                <Route exact path={routes.chatHistory}>
                  <ChatSection />
                </Route>
                <Route exact path={routes.questionPaper}>
                  <QuestionPaper />
                </Route>
                <Route exact path={routes.questionPaperView}>
                  <ViewQuestionPaper />
                </Route>

                <Route exact path={routes.sessiontimeTable}>
                  <TimeTable />
                </Route>
                <Route exact path={routes.sessiontimeTableNew}>
                  <TimeTableNew />
                </Route>
                <Route exact path={routes.contractManagement}>
                  <ContractManagement />
                </Route>
                <Route exact path={routes.subjectDocuments}>
                  <SubjectDocuments />
                </Route>
                <Route exact path={routes.gradingSetting}>
                  <GradingSetting />
                </Route>
                <Route exact path={routes.revaluationRetest}>
                  <RevaluationRetest />
                </Route>
                <Route exact path={routes.academicCalendar}>
                  <AcademicCalendar />
                </Route>
                {/* OLD NAV */}
                {/* <Route exact path={`${routes.department}`}>
                  <Department />
                </Route>
                <Route exact path={`${routes.bankaccount}`}>
                  <Bankaccount />
                </Route>
                <Route exact path={`${routes.employee}`}>
                  <Employee />
                </Route>
                <Route exact path={`${routes.designation}`}>
                  <Designation />
                </Route>
                <Route exact path={`${routes.payslip}`}>
                  <Payslip />
                </Route>
                <Route exact path={`${routes.shift}`}>
                  <Shift />
                </Route>
                <Route exact path={`${routes.workingday}`}>
                  <WorkingDays />
                </Route>
                <Route exact path={`${routes.leavepolicy}`}>
                  <LeavePolicy />
                </Route>
                <Route exact path={`${routes.holiday}`}>
                  <Holiday />
                </Route>
                <Route exact path={`${routes.mypayslip}`}>
                  <Mypayslip />
                </Route>
                <Route exact path={`${routes.investment}`}>
                  <Investment />
                </Route>
                <Route exact path={`${routes.main}/notification`}>
                  <Notification />
                </Route>
                <Route exact path={`${routes.main}/sendMail`}>
                  <SendMail />
                </Route>
                <Route exact path={`${routes.main}/sendSMS`}>
                  <Sms />
                </Route>
                <Route exact path={`${routes.main}/events`}>
                  <Event />
                </Route>
                <Route exact path={`${routes.main}/etl`}>
                  <Redirect to={`${routes.main}/etl/fileUpload`} />
                </Route>
                <Route exact path={`${routes.main}/etl/fileUpload`}>
                  <ETL history={history} />
                </Route>
                <Route exact path={`${routes.assignRoles}`}>
                  <AssignRoles />
                </Route>
                <Route exact path={`${routes.main}/notification`}>
                  <Notification />
                </Route>
                <Route
                  exact
                  path={`/${routes.timeTable}`}
                  component={TTMaster}
                ></Route> */}
              </Switch>
            </Suspense>
          </Box>
        </div>
      </Box>
    </>
  );
}



export default withRouter(Index);
